import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import { CircularProgress } from "material-ui/Progress";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Table, {
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "material-ui/Table";
import TextField from "material-ui/TextField";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import { FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import Radio from "material-ui/Radio";
import { RadioGroup } from "material-ui/Radio";
import Snackbar from "material-ui/Snackbar";
import Dialog, { DialogTitle, DialogActions } from "material-ui/Dialog";
import Select from "material-ui/Select";
import Switch from "material-ui/Switch";
import { MenuItem } from "material-ui/Menu";
import Grid from "material-ui/Grid";
import { get } from "../../services/apiServices";
import { post } from "../../services/apiServices";
import { token } from "../../services/authServices";
import ReactPaginate from "react-paginate";
import DotsLayoutDialog from './DotsLayoutDialog'

const styles = {
    closeIcon: {
        position: "absolute",
        top: "10px",
        right: "10px",
        color: "#a9a9a9",
        cursor: "pointer"
    },
    editIcon: {
        padding: "10px",
        cursor: "pointer"
    },
    button: {
        width: "120px",
        margin: "0 auto"
    },
    formControl: {
        width: "100%",
        minWidth: "120px"
    },
    grid: {
        margin: "0 -24px",
        padding: "0 30px",
        textAlign: "left"
    },
    customGrid: {
        padding: "0 12px !important"
    },
    titleWrap: {
        marginTop: "15px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    title: {
        color: "#3f51b5"
    },
    table: {
        minWidth: 700
    },
    tableRow: {
        cursor: "pointer"
    },
    progressWrapper: {
        display: "flex",
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    },
    progress: {},
    dotsDialog: {
        justifyContent: 'flex-start'
    }
};

class LevelSingle extends Component {
    constructor(props) {
        super(props);

        this.state = {
            levels: this.props.levels,
            open: false,
            openSnackbar: false,
            openConfirm: false,
            types: [],
            settings: {},
            id: "",
            deleteId: null,
            activeType: "",
            activeStageId: null,
            activeStageName: '',
            description: "",
            instruction: "",
            questions_count: "",
            challenge_unlock_question_count: '',
            challenge_text1: '',
            challenge_text2: '',
            challenge_text3: '',
            one_stars_rating_value: "",
            two_stars_rating_value: "",
            three_stars_rating_value: "",
            show_level_info: false,
            level_info: '',
            level_info_title: '',
            level_info_description: '',
            level_info_image_url: '',
            level_info_video_url: '',
            order: 0,
            status: true,
            message: "",
            dotsModalOpen: false,
        };
        this.disabled = false;
    }

    onSubmit = () => {
        let status = this.state.status ? "enabled" : "disabled";
        post(
            `/admin/levels/${this.props.levelId}`,
            {
                description: this.state.description,
                instruction: this.state.instruction,
                questions_count: this.state.questions_count,
                one_stars_rating_value: this.state.one_stars_rating_value,
                two_stars_rating_value: this.state.two_stars_rating_value,
                three_stars_rating_value: this.state.three_stars_rating_value,
                challenge_unlock_question_count: this.state.challenge_unlock_question_count,
                challenge_text1: this.state.challenge_text1,
                challenge_text2: this.state.challenge_text2,
                challenge_text3: this.state.challenge_text3,
                order: this.state.order,
                settings: this.state.settings,
                type: this.state.activeType,
                stage_id: this.state.activeStageId,
                status: status,
                show_level_info: this.state.show_level_info,
                level_info_title: this.state.level_info_title,
                level_info_description: this.state.level_info_description,
                level_info_image_url: this.state.level_info_image_url,
                level_image_auto: this.state.level_image_auto,
                //level_info: this.state.level_info ? this.state.level_info : '',
                level_info_video_url: this.state.level_info_video_url ? this.state.level_info_video_url : '',
            },
            token
        )
            .then(res => {
                this.props.getSingleLevel(this.props.levelId)
            })
            .catch(err => {
                this.setState({
                    openSnackbar: true,
                    message: "The given data was invalid."
                });
            });
    };

    getTypes = () => {
        get("/admin/levels/types", token).then(res => {
            if (res.status === 200)
                this.setState({ types: res.data });
        });
    };

    handleCloseSnackbar = () => {
        this.setState({
            openSnackbar: false,
            message: ""
        });
    };

    handleChange = e => {
        let newState = this.state;

        newState[e.target.name] = e.target.value;
        this.setState(newState);
    };

    handleSelectStageChange = e => {
        let activeStageId = e.target.value;
        this.setState({
            activeStageId
        });
    };

    handleSelectTypeChange = e => {
        let newState = this.state;
        let types = newState.types.data;
        let type = types.filter(item => item.key === e.target.value);
        let settings = type[0].settings;
        let settingsState = {};

        for (let setting in settings) {
            let item = settings[setting];

            settingsState[setting] = item.default;
        }

        this.setState({
            activeType: e.target.value,
            settings: settingsState
        });
    };

    handleSettingsChange = e => {
        let newState = this.state;

        newState.settings[e.target.name] = e.target.value;
        this.setState(newState);
    };

    handleToggle = e => {
        let newState = this.state;

        newState.settings[e.target.name] = !newState.settings[e.target.name];
        this.setState(newState);
    };

    handleFormMatrix = (matrix) => {
        let newState = this.state;
        newState.settings['form_matrix'] = matrix
        this.setState({ newState });
    };

    renderTypeSettings = () => {
        let types = this.state.types.data;
        let result = [];
        if (types instanceof Array && types.length > 0) {
            let type = types.filter(item => item.key === this.state.activeType);
            let settings = type[0].settings;
            this.disabled = false;

            for (let setting in settings) {
                let item = settings[setting];
                if(item["depends_on"] && (!this.state.settings || item["depends_on_value"] != this.state.settings[item["depends_on"]])) {
                    continue;
                }
                switch (item.type) {
                    case "text":
                        const flags = item.validation.replace(
                            /.*\/([gimy]*)$/,
                            "$1"
                        );
                        const pattern = item.validation.replace(
                            new RegExp("^/(.*?)/" + flags + "$"),
                            "$1"
                        );
                        const regex = new RegExp(pattern, flags);
                        const error = !regex.test(this.state.settings[setting]);

                        this.disabled = this.disabled ? this.disabled : error;
                        result.push(
                            <Grid
                                className={this.classes.customGrid}
                                item
                                sm={6}
                                key={setting}
                            >
                                <TextField
                                    error={error}
                                    id={setting}
                                    label={item.label}
                                    name={setting}
                                    defaultValue={this.state.settings[setting]}
                                    onChange={this.handleSettingsChange}
                                    margin="normal"
                                    fullWidth
                                />
                            </Grid>
                        );
                        break;
                    case "select":
                        result.push(
                            <Grid
                                className={this.classes.customGrid}
                                item
                                sm={12}
                                key={setting}
                            >
                                <FormControl className={this.classes.formControl}>
                                    <InputLabel htmlFor={setting}>
                                        {item.label}
                                    </InputLabel>
                                    <Select
                                        value={this.state.settings[setting]}
                                        onChange={this.handleSettingsChange}
                                        inputProps={{
                                            id: setting,
                                            name: setting
                                        }}
                                        autoWidth
                                    >
                                        {item.options
                                            ? item.options.map((i, index) => {
                                                return (
                                                    <MenuItem
                                                        key={index}
                                                        value={i}
                                                    >
                                                        {i}
                                                    </MenuItem>
                                                );
                                            })
                                            : ""}
                                    </Select>
                                </FormControl>
                            </Grid>
                        );
                        break;
                    case "number":
                        result.push(
                            <Grid
                                className={this.classes.customGrid}
                                item
                                sm={6}
                                key={setting}
                            >
                                <TextField
                                    id={setting}
                                    label={item.label}
                                    type="number"
                                    name={setting}
                                    value={this.state.settings[setting]}
                                    onInput={this.handleSettingsChange}
                                    margin="normal"
                                    fullWidth
                                />
                            </Grid>
                        );
                        break;
                    case "toggle":
                        result.push(
                            <Grid
                                className={this.classes.customGrid}
                                item
                                sm={6}
                                key={setting}
                            >
                                <InputLabel>{item.label}</InputLabel>
                                <div>
                                    <Switch
                                        checked={this.state.settings[setting]}
                                        name={setting}
                                        onChange={this.handleToggle}
                                        color="primary"
                                    />
                                </div>
                            </Grid>
                        );
                        break;
                    case "matrix":
                        result.push(
                            <Grid
                                className={this.classes.customGrid}
                                item
                                sm={6}
                                key={setting}
                            >
                                <Button
                                    variant="raised"
                                    color="primary"
                                    onClick={() => this.setState({ dotsModalOpen: true })}
                                >
                                    {item.label}
                                </Button>
                            </Grid>
                        );
                        break;
                }
            }
        }

        return result.map(item => item);
    };


    renderStageItems = () => {
        let items = this.props.stages;
        let result = [];

        if (items.data && items.data.length)
            [
                items.data.map((item, index) => {
                    result.push(
                        <MenuItem key={index} value={item.id}>
                            {item.name}
                        </MenuItem>
                    );
                })
            ];

        return result.map(item => item);
    };

    renderTypeItems = () => {
        let items = this.state.types;
        let result = [];

        if (items.data && items.data.length)
            [
                items.data.map((item, index) => {
                    result.push(
                        <MenuItem key={index} value={item.key}>
                            {item.name}
                        </MenuItem>
                    );
                })
            ];

        return result.map(item => item);
    };

    componentDidMount() {
        //this.getLevels(this.props.stageId);
        this.props.getSingleLevel(this.props.levelId)
        this.props.getStages()
        this.getTypes();
    }

    componentWillReceiveProps(props) {
        if (props.singleLevel.data) {

            let level = props.singleLevel.data;
            let newState = { ...this.state }

            newState.description = level.description
            newState.instruction = level.instruction
            newState.questions_count = level.questions_count
            newState.one_stars_rating_value = level.one_stars_rating_value
            newState.two_stars_rating_value = level.two_stars_rating_value
            newState.three_stars_rating_value = level.three_stars_rating_value
            newState.challenge_unlock_question_count = level.challenge_unlock_question_count
            newState.challenge_text1 = level.challenge_text1
            newState.challenge_text2 = level.challenge_text2
            newState.challenge_text3 = level.challenge_text3
            newState.order = level.order
            newState.settings = level.settings
            newState.activeType = level.type
            newState.activeStageId = level.stage_id
            newState.status = level.status === "enabled" ? true : false
            newState.show_level_info = level.show_level_info
            newState.level_info = level.level_info ? level.level_info : ''
            newState.level_info_title = level.level_info_title ? level.level_info_title : ''
            newState.level_info_description = level.level_info_description ? level.level_info_description : ''
            newState.level_info_image_url = level.level_info_image_url ? level.level_info_image_url : ''
            newState.level_info_image_url = level.level_info_image_url ? level.level_info_image_url : ''
            newState.level_image_auto = level.level_image_auto ? level.level_image_auto : false

            this.setState(newState);
        }

        if (props.stages.data) {
            let stageId = this.state.activeStageId
            let activeStageName = ''
            props.stages.data.forEach(item => {
                if (stageId === item.id) {
                    activeStageName = item.name
                }
            })
            this.setState({ activeStageName })
        }
    }

    classes = this.props.classes;

    render() {
        const { singleLevel } = this.props;
        const { activeStageName } = this.state
        let isFetching = singleLevel ? singleLevel.isFetching : true;
        let disable =
            !this.state.description ||
            !this.state.activeType ||
            !this.state.instruction ||
            !this.state.questions_count ||
            (this.state.order < 0 || this.state.order === "");

        return isFetching ? (
            <div className={this.classes.progressWrapper}>
                <CircularProgress className={this.classes.progress} size={50} />
            </div>
        ) : (
                <div>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "center"
                        }}
                        open={this.state.openSnackbar}
                        autoHideDuration={6000}
                        onClose={this.handleCloseSnackbar}
                        SnackbarContentProps={{
                            "aria-describedby": "message-id"
                        }}
                        message={<span id="message-id">{this.state.message}</span>}
                    />

                    <DotsLayoutDialog onChange={this.handleFormMatrix} open={this.state.dotsModalOpen} onClose={() => this.setState({ dotsModalOpen: false })} matrix={this.state.settings['form_matrix'] || []} />

                    {this.props.stages && <Grid className={this.classes.customGrid} item sm={12}>
                        <FormControl className={this.classes.formControl}>
                            <InputLabel htmlFor="stage-select">
                                Stage
                                    </InputLabel>
                            <Select
                                value={this.state.activeStageId || 0}
                                onChange={this.handleSelectStageChange}
                                inputProps={{
                                    id: "stage-select",
                                    name: "activeStageId"
                                }}
                                autoWidth
                            >
                                {this.renderStageItems()}
                            </Select>
                        </FormControl>
                    </Grid>}
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="description"
                            label="Description"
                            name="description"
                            multiline
                            rows="1"
                            value={this.state.description}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="instruction"
                            label="Instruction"
                            name="instruction"
                            multiline
                            rows="1"
                            value={this.state.instruction}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                    {activeStageName === 'Challenge' && 
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="challenge_text1"
                            label="Challenge Text 1 (Topic Title)"
                            name="challenge_text1"
                            multiline
                            rows="1"
                            value={this.state.challenge_text1}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>}
                    {activeStageName === 'Challenge' && 
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="challenge_text2"
                            label="Challenge Text 2 (Skill name)"
                            name="challenge_text2"
                            multiline
                            rows="1"
                            value={this.state.challenge_text2}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>}
                    {activeStageName === 'Challenge' && 
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="challenge_text3"
                            label="Challenge Text 3 (Skill subname)"
                            name="challenge_text3"
                            multiline
                            rows="1"
                            value={this.state.challenge_text3}
                            onChange={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>}
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="questions_count"
                            label="Questions count"
                            type="number"
                            name="questions_count"
                            value={this.state.questions_count}
                            onInput={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                    {activeStageName === 'Challenge' ? (<React.Fragment>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <TextField
                                id="challenge_unlock_question_count"
                                label="Unlock Questions Count"
                                type="number"
                                name="challenge_unlock_question_count"
                                value={this.state.challenge_unlock_question_count}
                                onInput={this.handleChange}
                                margin="normal"
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>) : (<React.Fragment>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <TextField
                                id="one_stars_rating_value"
                                label="1 Star Average Coin Count"
                                type="number"
                                name="one_stars_rating_value"
                                value={this.state.one_stars_rating_value}
                                onInput={this.handleChange}
                                margin="normal"
                                fullWidth
                            />
                        </Grid>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <TextField
                                id="two_stars_rating_value"
                                label="2 Star Average Coin Count"
                                type="number"
                                name="two_stars_rating_value"
                                value={this.state.two_stars_rating_value}
                                onInput={this.handleChange}
                                margin="normal"
                                fullWidth
                            />
                        </Grid>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <TextField
                                id="three_stars_rating_value"
                                label="3 Star Average Coin Count"
                                type="number"
                                name="three_stars_rating_value"
                                value={this.state.three_stars_rating_value}
                                onInput={this.handleChange}
                                margin="normal"
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>)}

                    <Grid className={this.classes.customGrid} item sm={6}>
                        <TextField
                            id="order"
                            label="Order"
                            type="number"
                            name="order"
                            value={this.state.order}
                            onInput={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                    <Grid className={this.classes.customGrid} item sm={6}>
                        <InputLabel>Status</InputLabel>
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.status}
                                        onChange={() =>
                                            this.setState({
                                                status: !this.state.status
                                            })
                                        }
                                        color="primary"
                                    />
                                }
                                label="Enabled"
                            />
                        </div>
                    </Grid>
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <InputLabel>Show Level Info</InputLabel>
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.show_level_info}
                                        onChange={() =>
                                            this.setState({
                                                show_level_info: !this.state.show_level_info
                                            })
                                        }
                                        color="primary"
                                    />
                                }
                                label="Show"
                            />
                        </div>
                    </Grid>
                    {/* this.state.show_level_info && <Grid className={this.classes.customGrid} item sm={12}>
                        <TextField
                            id="level_info"
                            label="Level Info"
                            type="text"
                            name="level_info"
                            value={this.state.level_info}
                            onInput={this.handleChange}
                            margin="normal"
                            multiline
                            fullWidth
                        />
                    </Grid> */}
                    {this.state.show_level_info && <React.Fragment>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <TextField
                                id="level_info_title"
                                label="Level Info Title"
                                type="text"
                                name="level_info_title"
                                value={this.state.level_info_title}
                                onInput={this.handleChange}
                                margin="normal"
                                multiline
                                fullWidth
                            />
                        </Grid>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <TextField
                                id="level_info_description"
                                label="Level Info Description"
                                type="text"
                                name="level_info_description"
                                value={this.state.level_info_description}
                                onInput={this.handleChange}
                                margin="normal"
                                multiline
                                fullWidth
                            />
                        </Grid>
                        <Grid className={this.classes.customGrid} item sm={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.level_image_auto}
                                        onChange={() => {
                                            let level = this.state.level;
                                            this.state.level_image_auto = !this.state.level_image_auto;
                                            this.setState({
                                                level
                                            });

                                        }

                                        }
                                        color="primary"
                                    />
                                }
                                label="Level Info Image Automatic?"
                            />
                            <TextField
                                id="level_info_image_url"
                                disabled={this.state.level_image_auto}
                                label="Level Info Image URL"
                                type="text"
                                name="level_info_image_url"
                                value={this.state.level_info_image_url}
                                onInput={this.handleChange}
                                margin="normal"
                                multiline
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>}
                    {/* this.state.show_level_info && <Grid className={this.classes.customGrid} item sm={6}>
                        <TextField
                            id="level_info_video_url"
                            label="Level Info Video Url"
                            type="text"
                            name="level_info_video_url"
                            value={this.state.level_info_video_url}
                            onInput={this.handleChange}
                            margin="normal"
                            fullWidth
                        />
                    </Grid> */}
                    <Grid className={this.classes.customGrid} item sm={12}>
                        <FormControl className={this.classes.formControl}>
                            <InputLabel htmlFor="type-select">
                                Type
                                </InputLabel>
                            <Select
                                value={this.state.activeType}
                                onChange={this.handleSelectTypeChange}
                                inputProps={{
                                    id: "type-select",
                                    name: "activeType"
                                }}
                                autoWidth
                            >
                                {this.renderTypeItems()}
                            </Select>
                        </FormControl>
                    </Grid>
                    {this.state.activeType ? this.renderTypeSettings() : []}
                    <Grid item sm={12}>
                        <DialogActions className="align-center">
                            <Button
                                variant="raised"
                                color="primary"
                                className={this.classes.button}
                                onClick={this.onSubmit}
                                disabled={this.disabled || disable}
                            >
                                Edit
                            </Button>
                        </DialogActions>
                    </Grid>
                </div>
            );
    }
}

export default withStyles(styles)(LevelSingle);



// WEBPACK FOOTER //
// ./src/components/content/LevelSingle.js